var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "image-carousel" }, [
    _c(
      "div",
      { staticClass: "swiper-container swiper-container--image-carousel" },
      [
        _c(
          "div",
          { staticClass: "swiper-wrapper" },
          _vm._l(_vm.images, function(image, index) {
            return _c("div", {
              key: index,
              staticClass: "swiper-slide w-1/3 object-fit",
              domProps: { innerHTML: _vm._s(image) }
            })
          }),
          0
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "svg",
      {
        staticClass: "button-next-slide",
        attrs: {
          height: "58",
          width: "58",
          xmlns: "http://www.w3.org/2000/svg"
        }
      },
      [
        _c(
          "g",
          {
            attrs: {
              fill: "none",
              "fill-rule": "evenodd",
              transform: "translate(1 1)"
            }
          },
          [
            _c("circle", {
              attrs: { cx: "28", cy: "28", r: "28", stroke: "#1A3A1B" }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M44.5 27.4090909c-2.6337527 0-4.783079-2.0740762-4.9037476-4.6779974L39.5909091 22.5H38.5c0 2.0878518 1.0664091 3.9266303 2.6842526 5.0013609L12.5 27.5v1l28.6832482-.0006935C39.5659678 29.5741308 38.5 31.4125803 38.5 33.5h1.0909091l.0053433-.2310935c.1206686-2.6039212 2.2699949-4.6779974 4.9037476-4.6779974v-1.1818182z",
                fill: "#0B1B0C",
                "fill-rule": "nonzero"
              }
            })
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "svg",
      {
        staticClass: "button-prev-slide",
        attrs: {
          height: "58",
          width: "58",
          xmlns: "http://www.w3.org/2000/svg"
        }
      },
      [
        _c(
          "g",
          {
            attrs: {
              fill: "none",
              "fill-rule": "evenodd",
              transform: "matrix(-1 0 0 1 57 1)"
            }
          },
          [
            _c("circle", {
              attrs: { cx: "28", cy: "28", r: "28", stroke: "#1A3A1B" }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M44.5 27.4090909c-2.6337527 0-4.783079-2.0740762-4.9037476-4.6779974L39.5909091 22.5H38.5c0 2.0878518 1.0664091 3.9266303 2.6842526 5.0013609L12.5 27.5v1l28.6832482-.0006935C39.5659678 29.5741308 38.5 31.4125803 38.5 33.5h1.0909091l.0053433-.2310935c.1206686-2.6039212 2.2699949-4.6779974 4.9037476-4.6779974v-1.1818182z",
                fill: "#0B1B0C",
                "fill-rule": "nonzero"
              }
            })
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }